import { Component, Input, Self, Optional } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import { InputBaseComponent } from '../inputbase/inputbase.component';

@Component({
  selector: 'lebara-select',
  templateUrl: './selectinput.component.html',
  styleUrls: ['../inputbase/inputbase.component.scss', './selectinput.component.scss']
})
export class SelectInputComponent extends InputBaseComponent implements ControlValueAccessor {
  public val?: number;

  @Input('items') items: Array<string>;

  constructor(@Self() @Optional() me: NgControl) {

    super(me);
    if (me) {
      me.valueAccessor = this;
    }
  }

  public get isEmpty(): boolean {
    return typeof this.val === 'undefined';
  }

  public onValueChange(event: Event): void {
    this.value = (event.target as any).selectedIndex;
  }

  public writeValue(value: any): void {
      this.val = value;
  }

  public set value(val: number) {
    // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
    this.val = val;
    this.onChange(val);
    this.onTouch(val);
  }
}
